export class ResidentsFilters {
  wingName: string;

  constructor() {
    this.wingName = '';
  }
}